import GlobalDownload from "./src/main.vue";

GlobalDownload.install = (Vue) => {
    Vue.component(GlobalDownload.name, GlobalDownload);
}

export default GlobalDownload;